import { DropdownMenu } from "@package/subframe/components/DropdownMenu";
import { IconButton } from "@package/subframe/components/IconButton";
import * as SubframeCore from "@subframe/core";
import { FeatherKey, FeatherMoreHorizontal, FeatherUser } from "@subframe/core";

interface EmployeeRowActionsProps {
  name: string;
  canResetPassword: boolean;
  onViewProfile: () => void;
  onResetPassword: () => void;
}

export function EmployeeRowActions({
  name,
  canResetPassword,
  onViewProfile,
  onResetPassword,
}: EmployeeRowActionsProps) {
  return (
    <SubframeCore.DropdownMenu.Root>
      <SubframeCore.DropdownMenu.Trigger asChild={true}>
        <IconButton
          variant="neutral-tertiary"
          size="medium"
          icon={<FeatherMoreHorizontal />}
          aria-label={`Actions for ${name}`}
        />
      </SubframeCore.DropdownMenu.Trigger>
      <SubframeCore.DropdownMenu.Portal>
        <SubframeCore.DropdownMenu.Content
          side="bottom"
          align="end"
          sideOffset={4}
          asChild={true}
        >
          <DropdownMenu>
            <DropdownMenu.DropdownItem
              icon={<FeatherUser />}
              onSelect={onViewProfile}
            >
              View profile
            </DropdownMenu.DropdownItem>
            {canResetPassword && (
              <DropdownMenu.DropdownItem
                icon={<FeatherKey />}
                onSelect={onResetPassword}
              >
                Reset password
              </DropdownMenu.DropdownItem>
            )}
          </DropdownMenu>
        </SubframeCore.DropdownMenu.Content>
      </SubframeCore.DropdownMenu.Portal>
    </SubframeCore.DropdownMenu.Root>
  );
}
